/* import __COLOCATED_TEMPLATE__ from './side-sheet.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/* RESPONSIBLE TEAM: team-frontend-tech */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import keycodes from '@intercom/pulse/lib/keynames';
import { ROOT_PARENT_SELECTOR } from '@intercom/pulse/lib/popover-utils';
let SideDrawer = (_class = class SideDrawer extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "eventListenerStack", _descriptor, this);
    _defineProperty(this, "rootParentElement", document.querySelector(ROOT_PARENT_SELECTOR));
    this.eventListenerStack.pushEventListener(this, 'keydown', this._handleKeyPress);
  }
  _handleKeyPress(event) {
    if (event.keyCode === keycodes.escape) {
      this.args.onClose && this.args.onClose();
    }
  }
  get addtionalRenderingContext() {
    return this.args.topLevelRender ? this.rootParentElement : undefined;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "eventListenerStack", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { SideDrawer as default };